import React from "react";
import styles from "./button.module.scss";

const Button = ({
  buttonText,
  icon,
  image,
  iconText,
  imageClassName = "",
  onClick,
  overrideClassName,
  
}
) => {
  return (
 
    <div className={`${styles.button} ${overrideClassName}`} onClick={onClick}>
      {icon && <i className={icon} />}
      {image && <img src={image} alt="icon" className={imageClassName} />}
      {iconText && <span>{iconText}</span>}
      {buttonText}
    </div>
  );
};

export default Button;
